import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { SummaryRow } from 'ui'
import styles from './styles'

type Props = {
  name: string
}

export function NameRow(props: Props) {
  return (
    <SummaryRow>
      <SummaryRow.Title>
        <FormattedMessage id="admin/promotions.form.general.name" />
      </SummaryRow.Title>
      <SummaryRow.Value>
        <Text className={styles.nameText}>{props.name}</Text>
      </SummaryRow.Value>
    </SummaryRow>
  )
}
